import { createSelector } from 'reselect'
import { generateBreadcrumb } from 'helpers/search/breadcrumb'
import lessonFilterTypes from 'helpers/enums/filters/lessonFilterTypes'

import filterTabs from 'helpers/enums/filters/tabs'
import { getLessonTypeText } from 'helpers/lesson/getLessonTypeText'

const getQS = state => state.qs
const getStore = state => state.store

const storeBreadcrumbSelector = createSelector(
	[ getQS, getStore ],
	(qsData, storeData) => {
		const selectedFilters = qsData.filters || []
		const currentFilters =
			storeData.currentTab === filterTabs.REGULAR_TAB ?
				storeData.categories : storeData.standard

		const breadcrumbItems =
			generateBreadcrumb(
				selectedFilters,
				storeData.currentTab,
				currentFilters,
				false
			)

		const isVideoLessonsFilterSelected =
			storeData.lessonTypeSelectedFilter[
				lessonFilterTypes.VIDEO
			]

		if (isVideoLessonsFilterSelected) {
			breadcrumbItems.unshift(
				getLessonTypeText(lessonFilterTypes.VIDEO)
			)
		}

		const isRegularLessonsFilterSelected =
			storeData.lessonTypeSelectedFilter[
				lessonFilterTypes.REGULAR
			]

		if (isRegularLessonsFilterSelected) {
			breadcrumbItems.unshift(
				getLessonTypeText(lessonFilterTypes.REGULAR)
			)
		}

		const isActivityFilterSelected =
			storeData.lessonTypeSelectedFilter[
				lessonFilterTypes.STANDALONE_ACTIVITIES
			]

		if (isActivityFilterSelected) {
			breadcrumbItems.unshift(
				getLessonTypeText(lessonFilterTypes.STANDALONE_ACTIVITIES)
			)
		}

		const breadcrumbSearchTerm = qsData.q ? qsData.q : ''

		let breadcrumbFilters = breadcrumbItems.join(' > ')
		if (breadcrumbSearchTerm && breadcrumbFilters) {
			breadcrumbFilters += breadcrumbSearchTerm ? ' > ' : ''
		}

		return {
			breadcrumbSearchTerm,
			breadcrumbFilters,
		}

	}
)

export default storeBreadcrumbSelector
